import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Hall() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        {/*
        <Box my={8}>
          <Paper className="p-3">
            <Typography className="font-weight-bold my-3 text-danger" variant="h5" component="h2">
              【ホール貸館休止のお知らせ】
            </Typography>
            <div className="text-danger">
              　新型コロナウイルス感染拡大防止のため、利用者の皆様の健康と安全を考慮し、現在ホールの貸館を休止させていただいております。<br />
              　再開の時期につきましては、対応が決まり次第、改めてご案内させていただきますので、よろしくお願い申し上げます。<br />
            </div>
          </Paper>
        </Box>
        */}

        {/*
        <Box my={8}>
          <Paper className="p-3">
            <Typography className="font-weight-bold my-3 text-danger" variant="h5" component="h2">
              【重要】価格改定のお知らせ
            </Typography>
            <div className="text-danger">
              いつも弊社ホールをご利用いただき、誠にありがとうございます。<br/>
              光熱費等の高騰より、２０２３年４月１日以降に提出されました申し込み書分より、価格変更を致します運びとなりました。<br/>
              皆様におかれましては、何卒ご理解くださいますようお願いいたします。（３月31日までに申し込み書を提出いただいた方につきましてはお申し込み時の料金となります。）<br/>
            </div>
          </Paper>
          <Paper className="p-3">
            <Typography className="font-weight-bold my-3 text-danger" variant="h5" component="h2">
              ６Fメディアホール 新規予約再開のお知らせ
            </Typography>
            <div className="text-danger">
              新型コロナウイルス感染拡大防止のため、６階メディアホールの新規予約を中止しておりましたが再開いたしました。ぜひご利用ください。<br/>
            </div>
          </Paper>
        </Box>
        */}

        <Box my={8}>
          <Grid spacing={4} container direction="row" justify="center">
            <a id="hall-1f" className="anchor"></a>
            <Grid item xs={12} md={6}>
              <Typography className="font-weight-bold my-3" variant="subtitle1" component="div">
                <ArrowRightIcon fontSize="large" />１階デーリー東北ホール
              </Typography>
              　新聞を印刷する「輪転機」をおいていた工場の跡地を活用した、13ｍの吹き抜けが特徴のホールです。<br/>
              　広さは約40坪、最大120脚のイスを並べることができます。<br/>
              　グランドピアノ（貸出有料）を常設し、音楽ライブや落語、地元ゆかりの芸術家の個展など、文化的なイベントが多く開催されています。<br/>
              <Box my={3}>
                <Grid spacing={1} container direction="row" justify="center">
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/1f001.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/1f002.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <img src="/images/hall/1f003.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/1f004.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/1f005.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/1f006.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/1f007.jpg" className="img-fluid" />
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <a id="hall-6f" className="anchor"></a>
            <Grid item xs={12} md={6}>
              <Typography className="font-weight-bold my-3" variant="subtitle1" component="div">
                <ArrowRightIcon fontSize="large" />６階メディアホール
              </Typography>
              　6階のホールは、主に会議や式典に使用されています。床は布張りで、長机とイスを１階ホールよりも多く設備し、大ホールでは200席ほどイスを並べることができます。<br/>
              　大ホールを仕切ることで中ホール（120席程度）と小ホール（80席程度）に分け、人数に即したホールの利用が可能です。<br/>
              <Box my={3}>
                <Grid spacing={1} container direction="row" justify="center">
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/6f001.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/6f002.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/6f003.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/6f004.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <img src="/images/hall/6f005.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/6f006.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <img src="/images/hall/6f007.jpg" className="img-fluid" />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>

          <a id="hall-price" className="anchor"></a>
          <Box my={8}>
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">
              ホール使用料金（税込）
            </Typography>
            <div class="fs90 text-danger line150 text-left m-3">
              ※来場者から入場料金を徴収する場合は入場料金に応じた割増料金、販売目的での会場使用の場合は通常使用料金の３倍の料金となります。<br/>
            </div>
            <Box my={4} textAlign="center">
              <Grid className="p-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <CustomButton href="/pdf/hall/hall-pricelist.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                    ホールご利用料金
                  </CustomButton>
                </Grid>
                <Grid item xs={12} md={4}>
                  <CustomButton href="/pdf/hall/hall-fixtureslist-20191129.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                    ホール貸出備品一覧
                  </CustomButton>
                </Grid>
                <Grid item xs={12} md={4}>
                  <CustomButton href="/pdf/hall/hall-drawing.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                    ホールの図面
                  </CustomButton>
                </Grid>
              </Grid>
            </Box>
          </Box>

          <a id="hall-entry" className="anchor"></a>
          <Box my={8}>
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">
              貸館申し込みについて
            </Typography>
            <dl>
              <dt>使用目的、空き状況の確認</dt>
              <dd>
                電話、ご来社で当ホールの空き状況を確認します。空き状況は、ご連絡いただいた時点でのものになります。<br/>
              </dd>
              <dt>「ホール使用申込書」の提出</dt>
              <dd>
                直接ご来社いただき、「ホール使用申込書」に必要事項を記入し、提出をお願いいたします。<br/>
                当ホールご利用ご希望の際は、<span className="border-double font-weight-bold">使用内容の詳細がわかるものをお持ちいただきますようお願いいたします。</span><br/>
              </dd>
            </dl>
            <Box my={4} textAlign="center">
              <Grid className="p-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <CustomButton href="/pdf/hall/hall-application.pdf" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                    ホールご使用申込書
                  </CustomButton>
                </Grid>
              </Grid>
            </Box>
            <dl>
              <dt>社内審査（一週間ほど掛かります）</dt>
              <dd>
                社内審査が通りましたら、担当からご連絡を差し上げます。その際にご利用料金をお知らせいたします。<br/>
              </dd>
              <dt>利用料金のお支払い</dt>
              <dd>
                ご利用料金を所定の期日までにお支払いください。当社で入金を確認しましたら、お申込み完了です。<br/>
                お支払い時の領収書、振込明細書をもって承諾書の代わりとさせていただきます。<br/>
              </dd>
              <dt>使用当日</dt>
              <dd>
                当日、催事責任者は、正面玄関の警備員に声をかけ、所定の用紙に入館時間をご記入ください。<br/>
                使用後も同様に退室時間を記載してください。<br/>
                使用物品は使用前の現状に戻していただきますようお願いいたします。<br/>
              </dd>
            </dl>
          </Box>

          <a id="hall-caution" className="anchor"></a>
          <Box my={8}>
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">
              ご利用にあたっての諸注意
            </Typography>
            <dl>
              <dt>予約について</dt>
              <dd>
                <ul>
                  <li>電話、FAX等での仮予約はできません。</li>
                  <li><span className="border-double font-weight-bold">連続してのご利用は、４日間まで</span>となります。</li>
                  <li>申込書をご提出いただいている場合でも、お支払い、またはご連絡の無い状態で他の申込があった場合、申込を取り消させていただく場合があります。</li>
                  <li>新聞休刊日、ホールメンテナンス時はご利用できません。日程等はホール担当までお問い合わせください。</li>
                  <li><span className="border-double font-weight-bold">ご予約は使用希望日より10カ月前の午前10時より可能</span>です。（該当日が休日の場合は、翌営業日の午前10時となります。）</li>
                  <li>使用希望日に複数の希望があった場合は、抽選となります。</li>
                  <li>デーリー東北新聞社（以下当社）主催事業が優先となりますので、予約解禁日にお貸しできない場合がございます。</li>
                  <li>広報物に会場名等を記載する場合は、ホールの利用許可後に担当のチェックを受けてください。</li>
                </ul>
              </dd>
            </dl>

            <dl>
              <dt>ご利用当日について</dt>
              <dd>
                <ul>
                  <li><span className="border-double font-weight-bold">本社1階受付にて、入館時間および退館時間のご記入をお願いします。</span></li>
                  <li>会場にはご利用時間の10分前より入場可能です。</li>
                  <li>近隣への騒音等の迷惑にならないよう、ご注意ください。</li>
                  <li>ホール利用時は、原則スタッフの付き添いはありません。備品の使用方法の確認など事前打ち合わせをお願いします。</li>
                  <li>ホール利用後は、原状復帰をお願いします。</li>
                  <li>備品、施設の破損・故障があった場合は、必ずご申告ください。（保険が適応になる場合があります）</li>
                  <li>本社２～５階は通常業務の職場のため、立ち入りは固く禁止いたします。</li>
                  <li>ホール、駐車場利用時の事故・盗難、トラブルに関して、当社では一切の責任を負いません。</li>
                </ul>
              </dd>
            </dl>

            <dl>
              <dt>利用料金の還付について</dt>
              <dd>
                <ul>
                  <li>
                    原則、入金後の返金はありませんが、次に該当する場合は利用料金をお返しします。
                    <ul class="decimal">
                      <li>災害、その他不可抗力により利用できなくなったとき。</li>
                      <li>公益上やむを得ない理由が生じ、利用できなくなったとき</li>
                    </ul>
                  </li>
                </ul>
              </dd>
            </dl>

            <dl>
              <dt>下記に当てはまる場合は、ご利用いただけません。</dt>
              <dd>
                <ul>
                  <li>公序良俗に反する行為を行う場合</li>
                  <li>高額な商品の売買、セミナー等への勧誘につながる企画の場合</li>
                  <li>政治、宗教などに関わる集会の場合</li>
                  <li>その他、デーリー東北新聞社が当社ホールでの開催に相応しくないと判断した場合。</li>
                </ul>
              </dd>
            </dl>

            <dl>
              <dt>下記に当てはまる行為は禁止します。</dt>
              <dd>
                <ul>
                  <li>許可を受けた目的以外での利用および、その権利を転貸、譲渡すること（請求書の宛名も同様）</li>
                  <li>火器、危険物、生き物の持ち込み</li>
                  <li>ホール壁面、床面等への画びょう、テープなどの使用</li>
                  <li>ホール内での喫煙</li>
                  <li>ホール内での飲食（1階デーリー東北ホールのみ可能ですが、事前にご相談ください。）</li>
                </ul>
              </dd>
            </dl>

            <dl>
              <dt>利用の取り消しについて</dt>
              <dd>
                <ul>
                  <li>
                    次の場合は、利用許可成立後または利用中であっても許可を取り消し、利用を中止させていただきます。その場合の利用料金は返還できません。
                    <ul class="decimal">
                      <li>当該ホール利用時の注意事項に違反したとき</li>
                      <li>当社が利用中止を判断したとき</li>
                    </ul>
                  </li>
                </ul>
              </dd>
            </dl>

            <dl>
              <dt>駐車場について</dt>
              <dd>
                <ul>
                  <li>俵屋様、しんぶんカフェ前の駐車場はご利用いただけません。</li>
                  <li>主催者は車両誘導係を設置し、所定の場所以外へ駐車をさせないよう徹底してください。</li>
                  <li>当社駐車場は台数に限りがあります。来場者に対しては、駐車場に限りがあることを周知してください。</li>
                </ul>
              </dd>
            </dl>

            <Box m={4}>
              <img src="/images/hall/hall-parking-trim.jpg" className="img-fluid" />
            </Box>
            {/*
            <dl>
              <dt>その他</dt>
              <dd>
                <ul>
                  <li>ホールで開催されるイベントのポスター、チラシは、デーリー東北ホール側に配置しますが、スペースに限りがあります。ご了承ください。</li>
                  <li>本社ビル、近隣への騒音等の迷惑にならないよう、ご注意ください。</li>
                  <li>ホール利用時、駐車場での事故、盗難、トラブルなどに関して、弊社では一切責任を負いません。  </li>
                </ul>
              </dd>
            </dl>
            */}
          </Box>
        </Box>

        <a id="hall-contactus" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            お問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北　ホール担当</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-80-7299<br/>
              <div> FAX:0178-47-0077</div>
              <div> E-mail:<a href="mailto:jigyo@daily-tohoku.co.jp">jigyo@daily-tohoku.co.jp</a></div>
              ※受付時間　午前10時～午後5時（月～金）<br />
              {/*
              ※2020年8月13日（木）〜8月16日（日）はお盆休みとなります。
              */}
            </dd>
          </dl>
        </Box>
      </div>
    </div>
  );
}

export default Hall;
